function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h50v50H0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.984 23.194v5.778c10.551 5.847 20.66 5.847 30.326 0 .035-.024.035-2.077 0-6.159",
  stroke: "#371447",
  strokeWidth: 1.042
}), /*#__PURE__*/React.createElement("path", {
  d: "M24.872 7.964l-23.65 8.701.003.286 23.646 9.68 23.616-9.682.01-.337-23.625-8.648z",
  stroke: "#371447",
  strokeWidth: 1.042,
  fill: "#9575CD"
}), /*#__PURE__*/React.createElement("path", {
  d: "M37.162 31.216h-1.526v-8.302c.024-.138.027-.23.008-.274-.035-.05-.18-.173-.424-.327l-10.177-5.27.7-1.364 10.232 5.3.027.016c.441.276.747.535.93.821.21.328.274.724.23 1.18v8.22z",
  fill: "#371447",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(21.081 14.934)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(12.403 13.757)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1.556 1.734l.775.559C.872 4.336.643 6.648 1.651 9.289l-.89.343C-.36 6.7-.097 4.048 1.556 1.734zm2.194-.028l.952.075c-.238 3.117.672 4.75 2.735 5.108l-.161.944c-2.62-.455-3.797-2.566-3.526-6.127z",
  fill: "#371447",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.327 2.47l.86.412c-.982 2.068-.833 4.027.453 5.942l-.79.536c-1.476-2.196-1.652-4.516-.523-6.89z",
  fill: "#371447",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.168 1.923l.93.219C3.4 5.144 3.875 6.965 5.45 7.748l-.423.86C2.977 7.585 2.382 5.31 3.168 1.922z",
  fill: "#371447",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("ellipse", {
  stroke: "#371447",
  strokeWidth: 1.042,
  fill: "#9575CD",
  cx: 3.035,
  cy: 1.69,
  rx: 1.606,
  ry: 1.643
})), /*#__PURE__*/React.createElement("ellipse", {
  stroke: "#371447",
  strokeWidth: 1.042,
  fill: "#9575CD",
  cx: 4.245,
  cy: 1.498,
  rx: 4.242,
  ry: 1.321
})), /*#__PURE__*/React.createElement("g", {
  stroke: "#371447"
}, /*#__PURE__*/React.createElement("g", {
  strokeWidth: 1.042
}, /*#__PURE__*/React.createElement("path", {
  d: "M7.358 31.398l15.367 8.024a2.891 2.891 0 011.55 2.43l.041.887a1.57 1.57 0 01-2.21 1.505l-17.1-7.659a2.891 2.891 0 01-1.462-3.808l.024-.053a2.752 2.752 0 013.79-1.326z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M25.907 40.866a2.882 2.882 0 00-1.017-1.721c-1.243-1.011-3.074-.808-4.09.453-1.016 1.26-.833 3.102.41 4.113 1.242 1.011 3.073.808 4.09-.453",
  fill: "#FFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.198 39.454l2.894 1.279c1.458-1.65 2.948-2.398 4.47-2.245.992.206-4.688-2.318-17.04-7.57-2.184-.036-3.53.799-4.037 2.505.096.03 2.624 1.137 7.583 3.325",
  fill: "#FFF"
})), /*#__PURE__*/React.createElement("path", {
  d: "M17.597 35.465a9.738 9.738 0 00-.939-.57 5.582 5.582 0 00-.988-.317c-1.312-.253-2.57.638-3.084 2.07-.191.535-.247.883-.25 1.37v.39c0 .168-.003.31-.011.459a3.037 3.037 0 000 .287l.006.18a1.58 1.58 0 01-.029.35c-.045.103-.045.103-.09.201l-.044.102A3.581 3.581 0 019.88 41.98c.062.013.128.022.197.026.351.02.597.01.773-.023.082-.016.27-.076.303-.082.124-.021.232.006.417.138.242.288.104.586-.204.868a2.247 2.247 0 01-.09.077 4.13 4.13 0 001.161-.01c.93-.142 1.774-.86 2.226-1.876.293-.658.34-1.382.148-2.056l-.01-.076c-.005-.605-.002-.867.02-1.139.095-1.162.982-2.037 2.775-2.362zm-6.398 7.001a1.591 1.591 0 000 0z",
  strokeWidth: 0.573,
  fill: "#371447"
})));

function SvgEducationMd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgEducationMd;